const BENIGN_RUNTIME_PATTERNS = [
  'ResizeObserver loop',
  'ResizeObserver loop limit exceeded',
  'ResizeObserver callback loop',
  'Failed to execute \'getBoundingClientRect\' on \'DOMRectReadOnly\'',
];

export function isBenignRuntimeError(message) {
  if (!message || typeof message !== 'string') return false;
  return BENIGN_RUNTIME_PATTERNS.some((pattern) => message.includes(pattern));
}

export function getMemorySnapshot() {
  const perf = globalThis.performance;
  const mem = perf && perf.memory;
  if (!mem || typeof mem.usedJSHeapSize !== 'number' || typeof mem.jsHeapSizeLimit !== 'number') {
    return {
      available: false,
      low: false,
      critical: false,
      ratio: 0,
      used: 0,
      limit: 0,
    };
  }

  const used = Number(mem.usedJSHeapSize) || 0;
  const limit = Number(mem.jsHeapSizeLimit) || 1;
  const ratio = limit > 0 ? used / limit : 0;
  return {
    available: true,
    low: ratio >= 0.78,
    critical: ratio >= 0.9,
    ratio,
    used,
    limit,
  };
}

export function addMemoryPressureListener(onPressure) {
  if (typeof onPressure !== 'function') return () => {};

  const notify = (source = 'poll') => {
    const snapshot = getMemorySnapshot();
    onPressure({ ...snapshot, source });
  };

  const handleMemoryEvent = () => notify('memorypressure');
  const dispatchCustom = () => notify('custom');

  const startPolling = () => {
    notify('initial');
    const poll = setInterval(() => {
      const snapshot = getMemorySnapshot();
      if (snapshot.critical || snapshot.low) {
        notify('poll');
      }
    }, 15000);
    return poll;
  };

  if ('addEventListener' in window) {
    window.addEventListener('memorypressure', handleMemoryEvent);
    window.addEventListener('world-traveler-memory-pressure', dispatchCustom);
  }

  const pollId = startPolling();

  return () => {
    if ('removeEventListener' in window) {
      window.removeEventListener('memorypressure', handleMemoryEvent);
      window.removeEventListener('world-traveler-memory-pressure', dispatchCustom);
    }
    clearInterval(pollId);
  };
}

export function triggerMemoryPressureEvent() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('world-traveler-memory-pressure', {
    detail: getMemorySnapshot(),
  }));
}
